import { IInfiniteData } from '../../../../types';

import { IEvaluationsListItemsData } from '../../../types';

/**
 * Format the response of the evaluation list items.
 */
export function formatEvaluationsListResponse(
  data: IInfiniteData<IEvaluationsListItemsData> | undefined
): IEvaluationsListItemsData {
  if (!data?.pages) return { evaluations: [], total: 0 };

  let total = 0;
  const evaluations = data.pages.flatMap((page) => {
    // all page will have the same total count
    total = page.total;
    // split assetname by a comma and use first part as the brand name
    page.evaluations.forEach((evaluation) => {
      if (evaluation.assetName) {
        const [brandName = ''] = evaluation.assetName.split(',');

        // TODO: @divyansh to look into this and remove the param reassignment
        // eslint-disable-next-line no-param-reassign
        evaluation.brandName = brandName.trim();
      }
    });

    return page.evaluations;
  });

  return { evaluations, total };
}
